<div class="form-main-block {{partnerName}}">
    <div class="form-boxes" id="form-boxes-info">
        <div id="section_{{p+1}}" *ngFor="let section of CannabisJSON;let p=index;">
            <app-accordion [expanded]="true" [showExpand]="false" [partnerName]="partnerName" [title]="section.title" [section]="section.sectionNumber">
                <ng-container *ngFor="let quest of section.questions;let i=index">
                    <ng-container *ngIf="showQuestion(quest)">
                        <div class="form-box-block" id="section_{{section.sectionNumber}}_question_{{quest.questionNumber}}_info">
                            <div class="form-number">{{getQuestionNumber(section, quest, p, i)}}.</div>
                            <div class="form-box">
                                <div class="form-detail">
                                    <div class="form-title">
                                        <span>{{quest.question}}</span>
                                    </div>
                                    <div class="form-detail-block" [innerHTML]="quest.questionInfo"></div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </app-accordion>
        </div>
    </div>
</div>
